import React, { useCallback } from 'react';
import { Icon } from '@/components/Icon';
import { Icons } from '@/assets';
import { SearchContainerCard } from '@/screens/Search/SearchContainerCard';
import { removeNoScroll } from '@/actions/Helper';
import { getMarketByCity } from '@/actions';
import { useInfiniteScroll } from '@/hooks/useInfiniteScroll';
import LoadingV2 from '@/components/Loading';

const LocationOffersModal = ({
  isOpen,
  onClose,
  locationData,
  openReserve,
  handleAddToFavList,
  savedList,
  setReserveInformation,
  reservedItem,
}) => {
  const fetchApi = useCallback(
    (page) => getMarketByCity(locationData?.city, page),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [locationData?.city]
  );

  const { items: containerData, loading } = useInfiniteScroll(fetchApi, {
    deps: [locationData?.city],
    responseDataKey: 'data',
  });

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleClose = () => {
    removeNoScroll();
    onClose();
  };

  return (
    <div
      className={`fixed top-0 right-0 bottom-0 left-0 z-50 flex justify-end transition-opacity duration-300 ${
        isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
      }`}
      style={{
        zIndex: 99999999,
      }}>
      {/* Backdrop */}
      <div
        className="absolute top-0 right-0 bottom-0 left-0 h-full w-full"
        style={{
          background: 'rgba(19, 21, 23, 0.16)',
        }}
        onClick={handleBackdropClick}
      />

      {/* Modal Content */}
      <div
        className={`fixed shadow-modal-paper top-0 right-0 h-full flex flex-col bg-white pt-4 pb-2  `}
        style={{
          transform: isOpen ? 'translateX(0%)' : 'translateX(100%)',
          transition: 'transform 0.3s ease-out',
          width: '326px',
        }}
        onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="px-3">
          <div className="flex items-center pb-3 justify-between border-b border-l-0 border-r-0 border-t-0 border-solid border-border-tertiary">
            <div className="flex items-center gap-2 truncate">
              <Icon src={Icons.locMap} width={24} height={24} />
              <h2 className="text-base font-normal  text-gray-1000 m-0 truncate">
                Active Offers on{' '}
                <span className="font-bold text-primary-blue">
                  {locationData?.city || 'Location'}
                </span>
              </h2>
            </div>
            <button
              onClick={handleClose}
              className="bg-transparent shadow-none border-none cursor-pointer"
              aria-label="Close modal">
              <Icon src={Icons.xIconBlack} width={20} height={20} />
            </button>
          </div>
        </div>
        <div className="px-3">
          <div className="text-center text-xs text-inactive-text my-2 py-2 shadow-table-header bg-border-light-secondary rounded border border-solid border-light-bg">
            total of
            <span className="font-bold text-primary-text">
              {' '}
              {containerData.length} active offers
            </span>{' '}
            are currently available
          </div>
        </div>
        {/* Content */}
        <div className="flex-1 overflow-y-auto px-3 py-2">
          {!loading && containerData.length === 0 ? (
            <div className="flex flex-col items-center justify-center mt-16">
              <Icon src={Icons.infoEmptyList} width={24} height={24} />
              <p className="text-inactive-text font-bold text-lg m-0 mt-4 mb-1">
                No containers found
              </p>
              <p className=" text-inactive-text text-base m-0 mb-6">
                No active offers available for this location
              </p>
            </div>
          ) : (
            !(loading && containerData.length === 0) &&
            containerData.map((containerItem) => (
              <SearchContainerCard
                noImage
                key={containerItem.id}
                containerItem={containerItem}
                openReserve={openReserve}
                handleAddToFavList={handleAddToFavList}
                savedList={savedList}
                setReserveInformation={setReserveInformation}
                reservedItem={reservedItem}
              />
            ))
          )}

          {loading &&
            (containerData.length === 0 ||
              (containerData && containerData.length > 0)) && (
              <div className="flex justify-center py-4">
                <LoadingV2 />
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default LocationOffersModal;
